const origin = 'systemMaintenance';

const FETCH_SYSTEM_MAINTENANCE_DETAILS = `${origin}/fetch`;
const FETCH_SYSTEM_MAINTENANCE_DETAILS_SUCCESS = `${origin}/fetchSuccess`;

export {
  FETCH_SYSTEM_MAINTENANCE_DETAILS,
  FETCH_SYSTEM_MAINTENANCE_DETAILS_SUCCESS,
};
